import React from 'react';
import { Mail, Heart, Sparkles } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black/20 backdrop-blur-xl mt-20">
      <div className="container mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 justify-center md:justify-start mb-3">
              <Sparkles className="h-6 w-6 text-purple-400" />
              <p className="text-xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                AttractivenessAI
              </p>
            </div>
            <p className="text-sm text-gray-400">
              © 2024 AttractivenessAI. All rights reserved.
            </p>
            <p className="text-xs text-gray-500 mt-2">
              AI-powered attractiveness analysis for modern dating
            </p>
          </div>
          
          <div className="flex flex-col items-center md:items-end gap-3">
            <a 
              href="mailto:karims11@icloud.com"
              className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-purple-400 transition-colors bg-white/5 px-4 py-2 rounded-full backdrop-blur-xl border border-white/10"
            >
              <Mail className="h-4 w-4" />
              <span>Support: karims11@icloud.com</span>
            </a>
            <p className="text-xs text-gray-500 flex items-center gap-1">
              Made with <Heart className="h-3 w-3 text-red-400 fill-red-400" /> for better connections
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;